module.exports = __webpack_public_path__ + "img/tu_28.1e5777fa.jpg";